import { useQuery } from '@apollo/client';
import { useAccount } from '@bnnvara/accounts';
import { useBrand } from '@bnnvara/brand';
import { SingleTeaser } from '@bnnvara/teasers';
import get from 'lodash/get';
import React from 'react';
import { withTheme } from 'styled-components';

import { FetchTeaserWithPage } from '../../api/queries/teaser.gql';
import resizeImageSource from '../../helpers/resizeImageSource';
import BaseTeaser from '../BaseTeaser';
import Link from '../Link';
import MediaPlayerEmbed from '../MediaPlayerEmbed';

const TeaserContent = () => {
  const brand = useBrand();
  const {
    profile: { UID },
  } = useAccount();

  const { loading, error, data } = useQuery(FetchTeaserWithPage, {
    skip: brand.isCached,
    variables: {
      brandSlug: brand.slug,
      label: 'teasers',
      slug: 'over',
    },
  });

  if (brand.isCached) {
    return null;
  }

  if (loading || error || data.brand === null) return null;

  const {
    brand: { teaser, page },
  } = data;

  const allTeaserItems = teaser ? teaser.items : [];

  if (teaser && allTeaserItems.length) {
    const items = allTeaserItems.slice(0, 3);

    const video = items[0].title && items[0].video && (
      <MediaPlayerEmbed
        type="video"
        title={items[0].title}
        id={items[0].video.id}
        siteName={brand.name}
        userId={UID}
      />
    );

    return <BaseTeaser items={items} video={video} LinkComponent={Link} />;
  }

  if (page) {
    const image = get(page, 'thumbnail', null);
    const backgroundColor = ({ theme }) => theme.tertiary.main;
    // uncomment for red color @ portal
    // const backgroundColor =
    // brand.slug === 'portal'
    //   ? ({ theme }) => theme.base.red
    //   : ({ theme }) => theme.tertiary.light;

    return (
      <SingleTeaser
        title={page.title}
        text={page.description}
        image={resizeImageSource(image, 680)}
        link={`${brand.slug}/${page.slug}`}
        linkText="lees meer"
        LinkComponent={Link}
        backgroundColor={backgroundColor}
      />
    );
  }

  return null;
};

export default withTheme(TeaserContent);
